document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("feedback-toolbar")) {
        const feedbackContainer = document.getElementById("feedback-toolbar");
        // Open btn
        //
        const openBtn = feedbackContainer.querySelector(
            ".feedback-toolbar-open-btn"
        );

        const openBtnCb = () => {
            feedbackContainer.classList.add("feedback-toolbar-open");
            feedbackContainer.style.zIndex = 999999999999;
        };
        openBtn.addEventListener("click", openBtnCb);

        // Close btn
        //
        const closeBtn = feedbackContainer.querySelector(
            ".feedback-toolbar-close-btn"
        );
        const closeBtnCb = () => {
            feedbackContainer.classList.remove("feedback-toolbar-open");
            feedbackContainer.style.zIndex = 99999999;
        };
        closeBtn.addEventListener("click", closeBtnCb);
    }
});
